import { withButtonAlignment } from '@skyscanner-internal/backpack-web/bpk-component-icon';
import BpkCloseCircleIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/close-circle';
import BpkText, { TEXT_STYLES } from '@skyscanner-internal/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner-internal/backpack-web/bpk-react-utils';
import { useTranslations } from '@web-platform/shared-travel-tools-utils-frontend';

import type { BpkInputRenderProps } from '@skyscanner-internal/backpack-web/bpk-component-autosuggest/src/BpkAutosuggestV2/BpkAutosuggest';

import STYLES from '../OriginAutosuggest.module.scss';

const cls = cssModules(STYLES);

const AlignedCloseIcon = withButtonAlignment(BpkCloseCircleIcon);

export type OriginInputProps = BpkInputRenderProps & {
  placeholder?: string;
  searchQuery: string;
  onClearQuery: () => void;
};

export const OriginInput = ({
  onClear,
  onClearQuery,
  placeholder,
  ref,
  searchQuery,
  ...rest
}: OriginInputProps) => {
  const { translate } = useTranslations();

  const handleClear = (e: React.MouseEvent<HTMLButtonElement>) => {
    onClearQuery();
    onClear?.(e);
  };

  return (
    <div className={cls('inputBox')}>
      <BpkText textStyle={TEXT_STYLES.bodyDefault} className={cls('inputPrefix')}>
        {translate('travel_confidence_map_filter_from_prefix')}
      </BpkText>
      <input {...rest} ref={ref} className={cls('bareInput')} placeholder={placeholder} />
      {(rest.value || searchQuery) && (
        <button
          aria-label={translate('travel_confidence_map_search_clear')}
          className={cls('clearButton')}
          onClick={handleClear}
          type="button"
        >
          <AlignedCloseIcon />
        </button>
      )}
    </div>
  );
};
